export const isDev = process.env.NEXT_PUBLIC_ENVIRONMENT === 'dev'
export const isTest = process.env.NEXT_PUBLIC_ENVIRONMENT === 'test'
export const isProd = process.env.NEXT_PUBLIC_ENVIRONMENT === 'prod'
